import React, { useEffect, useState } from 'react';
import { ArrowUpRight, CalendarDays } from 'lucide-react';
import guardadas from '../data/novedades.json';
import { trackEvent } from '../lib/analytics';

// Últimas actividades desde el Instagram de la UIQ.
// Se muestran primero las guardadas al publicar (scripts/novedades.js) y enseguida se
// reemplazan por las del día (función novedades-diaria → /api/novedades).
const fechaLarga = (iso) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString('es-AR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });

export const Novedades = () => {
  const [novedades, setNovedades] = useState(guardadas);

  useEffect(() => {
    let activo = true;
    fetch('/api/novedades')
      .then((r) => (r.ok ? r.json() : null))
      .then((lista) => {
        if (activo && Array.isArray(lista) && lista.length) setNovedades(lista);
      })
      .catch(() => {});
    return () => {
      activo = false;
    };
  }, []);

  if (!novedades || !novedades.length) return null;
  return (
    <div className="mt-8 sm:mt-10" data-testid="novedades">
      <div className="flex items-end justify-between gap-4 mb-4 sm:mb-6">
        <div>
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">Últimas actividades</h3>
          <p className="mt-1 text-sm sm:text-base text-gray-600">Lo que estuvimos haciendo, directo desde nuestro Instagram.</p>
        </div>
      </div>

      <div className="-mx-4 px-4 md:mx-0 md:px-0 flex md:grid md:grid-cols-3 gap-4 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-pl-4 md:scroll-pl-0 pb-2 md:pb-0">
        {novedades.map((n) => (
          <article
            key={n.id}
            className="snap-start shrink-0 w-[82%] sm:w-[60%] md:w-auto bg-white rounded-2xl border border-gray-100 shadow-lg overflow-hidden flex flex-col"
          >
            <a href={n.url} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('click_novedad', { id: n.id })} className="block aspect-square overflow-hidden bg-gray-100">
              <img src={n.imagen} alt={n.titulo} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
            </a>
            <div className="p-5 sm:p-6 flex flex-col flex-1">
              <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-blue-600">
                <CalendarDays className="w-3.5 h-3.5" />
                <time dateTime={n.fecha}>{fechaLarga(n.fecha)}</time>
              </p>
              <h4 className="mt-2 text-lg font-bold text-gray-900 leading-snug">{n.titulo}</h4>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed line-clamp-3">{n.texto}</p>
              <a
                href={n.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('click_novedad', { id: n.id })}
                className="mt-auto pt-4 inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-700"
              >
                Ver en Instagram
                <ArrowUpRight className="ml-1 w-4 h-4" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
